import React from 'react';
import { Link } from 'react-router-dom';

const GettingStarted: React.FC = () => {
  return (
    <div className="prose max-w-none">
      <h2 className="text-2xl font-semibold text-gray-800 mb-2">Getting Started</h2>
      <p className="text-gray-600 mb-4">Follow these steps to set up your account and start managing compliance.</p>

      <ol className="list-decimal ml-6 space-y-3 text-gray-800">
        <li>
          <span className="font-medium">Create or select an organization</span>
          <div className="text-sm text-gray-600">Go to <Link to="/organizations" className="text-primary-600 underline">Organizations</Link> and create a new organization or select an existing one.</div>
        </li>
        <li>
          <span className="font-medium">Add locations</span>
          <div className="text-sm text-gray-600">Navigate to <Link to="/locations" className="text-primary-600 underline">Locations</Link> and add each site you manage.</div>
        </li>
        <li>
          <span className="font-medium">Load or create compliance templates</span>
          <div className="text-sm text-gray-600">Open <Link to="/compliance-management" className="text-primary-600 underline">Compliances</Link>, click “Load Default Templates” or “+ Add Compliance”. Ensure each template has alert times (days) and required evidence as needed.</div>
        </li>
        <li>
          <span className="font-medium">Assign templates to locations</span>
          <div className="text-sm text-gray-600">From <Link to="/organizations" className="text-primary-600 underline">Organizations</Link> or <Link to="/locations" className="text-primary-600 underline">Locations</Link>, assign compliance templates to locations to generate tasks.</div>
        </li>
        <li>
          <span className="font-medium">Create checklists, forms, or agreements (Optional)</span>
          <div className="text-sm text-gray-600">
            Enhance your compliance workflows by creating custom <Link to="/checklists" className="text-primary-600 underline">Checklists</Link>, <Link to="/forms" className="text-primary-600 underline">Forms</Link>, or <Link to="/agreements" className="text-primary-600 underline">Agreements</Link>. These can be attached to compliance templates to provide structured ways for staff members to complete tasks. Staff can run these items to capture photos, fill out forms, or sign documents as part of the compliance process.
          </div>
        </li>
        <li>
          <span className="font-medium">Work tasks</span>
          <div className="text-sm text-gray-600">Go to <Link to="/tasks" className="text-primary-600 underline">Tasks</Link>, complete a task, and upload required evidence. If a task has an associated checklist, form, or agreement, staff members can run it to complete the required steps. AI can parse documents and suggest the next due date from expiry.</div>
        </li>
        <li>
          <span className="font-medium">Manager review</span>
          <div className="text-sm text-gray-600">Tasks move to <span className="font-medium">Pending Review</span>. Managers review and mark as completed; then the next task is generated using AI-suggested or frequency-based due date.</div>
        </li>
        <li>
          <span className="font-medium">Access Evidence Vault</span>
          <div className="text-sm text-gray-600">
            Visit the <Link to="/evidence-vault" className="text-primary-600 underline">Evidence Vault</Link> to view and search all collected documents, checklists, forms, and agreements across your organization. Filter by location, type, or document name to quickly find specific evidence. Click on any item to view detailed information, photos, and completed forms.
          </div>
        </li>
      </ol>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-4 gap-3">
        <Link to="/organizations" className="btn-primary text-center px-4 py-2">Go to Organizations</Link>
        <Link to="/locations" className="btn-secondary text-center px-4 py-2">Add Locations</Link>
        <Link to="/compliance-management" className="btn-secondary text-center px-4 py-2">Manage Compliances</Link>
        <Link to="/evidence-vault" className="btn-secondary text-center px-4 py-2">Evidence Vault</Link>
      </div>
    </div>
  );
};

export default GettingStarted;


